import { withStyles } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import withFeatureToggles from 'shell/hoc/withFeatureToggles';
import withStylyze from 'shell/hoc/withStylyze';
import withUserGroupMembershipBOH from 'shell/hoc/withUserGroupMembershipBOH';
import { compose } from 'redux';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { CLIENTELING_CHAT_TOGGLE, GLOBAL_NAV_HOME, STATEFUL_GLOBAL_NAV } from 'constants/featureToggleNames';

import GlobalNav from './GlobalNav';
import styles from './GlobalNav.styles';
import { getMessageNotificationForAssociate, getNotificationCountForAssociate } from '../../../../graphQL/query';

const mapStateToProps = ({ user, globalNavigation, userGroups: { activeADGroup } }) => ({
  user: user.data,
  isVisible: globalNavigation.isVisible,
  activeADGroup,
});

export default compose(
  withRouter,
  withFeatureToggles({
    isHomePageEnabled: GLOBAL_NAV_HOME,
    isChatEnabled: CLIENTELING_CHAT_TOGGLE,
    isStatefulGlobalNav: STATEFUL_GLOBAL_NAV,
  }),
  connect(mapStateToProps),
  graphql(getMessageNotificationForAssociate, {
    options: ({ user, activeADGroup }) => ({
      fetchPolicy: 'no-cache',
      variables: {
        associateId: user?.employeeNumber,
      },
      context: {
        headers: {
          'X-NMG-Group': activeADGroup,
        },
      },
    }),
    props: (props) => ({
      notifications: props.data.getMessageNotificationForAssociate,
      refetchMessageCount: props.data.refetch,
    }),
  }),
  graphql(getNotificationCountForAssociate, {
    options: ({ user, activeADGroup }) => ({
      fetchPolicy: 'no-cache',
      variables: {
        associateId: user?.employeeNumber,
      },
      context: {
        headers: {
          'X-NMG-Group': activeADGroup,
        },
      },
    }),
    props: (props) => ({
      alertNotifications: props.data.getNotificationCountForAssociate || [],
    }),
  }),
  withStylyze,
  withStyles(styles),
  withUserGroupMembershipBOH(),
)(GlobalNav);
